import { useStore } from 'src/contexts/StoreContext';
import { observer } from 'mobx-react-lite';
import { BottomSheetLookupOptions } from '../bottom-sheet-lookup-options/BottomSheetLookupOptions';
import { BottomSheetLookupsList } from '../bottom-sheet-lookups-list/BottomSheetLookupsList';
import BottomSheetUpselling from '../bottom-sheet-upselling/BottomSheetUpselling';
import { BOTTOM_SHEET_VIEWS } from 'src/store/bottom-sheet/bottomSheet.constants';
import { BottomSheetAdjustments } from '../bottom-sheet-adjustments/BottomSheetAdjustments';
import { BottomSheetPrivacyPolicy } from '../bottom-sheet-privacy-policy/BottomSheetPrivacyPolicy';
import { BottomSheetPhotoDrawer } from '../bottom-sheet-photo-drawer/BottomSheetPhotoDrawer';
import { BottomSheetSourceUpload } from '../bottom-sheet-source-upload/BottomSheetSourceUpload';
import { BottomSheetSaveProject } from '../bottom-sheet-save-project/BottomSheetSaveProject';
import { BottomSheetLogin } from '../bottom-sheet-login/BottomSheetLogin';
import { BottomSheetAvoidCuts } from '../bottom-sheet-avoid-cuts/BottomSheetAvoidCuts';
import { BottomSheetDiscount } from 'src/editor-v3/components/bottom-sheet-discount/BottomSheetDiscount';
import { BottomSheetSharePhotos } from '../bottom-sheet-share-photos/BottomSheetSharePhotos';
import { ViewStyle } from 'react-native';
import { BottomSheetGroupTabs } from '../bottom-sheet-group-tabs/BottomSheetGroupTabs';

const BottomSheetMap: Record<BOTTOM_SHEET_VIEWS, ({ bsStyle }: { bsStyle: ViewStyle }) => JSX.Element> = {
  [BOTTOM_SHEET_VIEWS.LookupOptions]: BottomSheetLookupOptions,
  [BOTTOM_SHEET_VIEWS.LookupsList]: BottomSheetLookupsList,
  [BOTTOM_SHEET_VIEWS.PhotoDrawer]: BottomSheetPhotoDrawer,
  [BOTTOM_SHEET_VIEWS.Upselling]: BottomSheetUpselling,
  [BOTTOM_SHEET_VIEWS.Adjustments]: BottomSheetAdjustments,
  [BOTTOM_SHEET_VIEWS.PrivacyPolicy]: BottomSheetPrivacyPolicy,
  [BOTTOM_SHEET_VIEWS.SourceUpload]: BottomSheetSourceUpload,
  [BOTTOM_SHEET_VIEWS.SaveProject]: BottomSheetSaveProject,
  [BOTTOM_SHEET_VIEWS.Login]: BottomSheetLogin,
  [BOTTOM_SHEET_VIEWS.AvoidCuts]: BottomSheetAvoidCuts,
  [BOTTOM_SHEET_VIEWS.DiscountTable]: BottomSheetDiscount,
  [BOTTOM_SHEET_VIEWS.SharePhotos]: BottomSheetSharePhotos,
  [BOTTOM_SHEET_VIEWS.GroupTabs]: BottomSheetGroupTabs,
};

/**
 * This component is a mobile-specific implementation of a bottom sheet project.
 * It uses the BottomSheetMap to determine which bottom sheet view to render based on the current bottomSheetView state.
 *
 * @returns JSX.Element
 */
export const BottomSheetProjectMobile = observer(({ bsStyle }: { bsStyle: ViewStyle }): JSX.Element => {
  const {
    bottomSheet: { bottomSheetView },
  } = useStore();

  const Component = BottomSheetMap[bottomSheetView];
  return Component ? <Component bsStyle={bsStyle} /> : <></>;
});
